const CONFIG = {
  apiUrl: "https://thecarptank-energy.soft-tree-b4c9.workers.dev",
  refreshMs: 2000,
  batteryNominalKwh: 20.72,
  usableFraction: 1.00,
  chartPoints: 90
};

const $ = id => document.getElementById(id);
const history = { labels: [], load: [], battery: [] };
let animations = {};

function formatRuntime(hours){
  if (!Number.isFinite(hours) || hours <= 0) return "—";
  const h = Math.floor(hours);
  const m = Math.round((hours - h) * 60);
  return `${h} h ${String(m).padStart(2,"0")} m`;
}

function updateBatteryVisual(percent, charging){
  const fill = $("batteryFill");
  fill.style.setProperty("width", `${Math.max(0,Math.min(100,percent))}%`, "important");
  fill.classList.toggle("charging", charging);

  let gradient;
  if(percent <= 20) gradient = "linear-gradient(90deg,#ef4444,#fb7185)";
  else if(percent <= 40) gradient = "linear-gradient(90deg,#f59e0b,#facc15)";
  else gradient = "linear-gradient(90deg,#45d275,#8ce8a8)";
  fill.style.setProperty("background", gradient, "important");
}

function stopFlow(name){
  if(animations[name]){
    cancelAnimationFrame(animations[name].frame);
    animations[name] = null;
  }
  const dot = $(name + "Dot");
  if(dot) dot.classList.remove("running");
}

function startFlow(name, durationMs, reverse=false){
  const path = $(name + "Path");
  const dot = $(name + "Dot");
  if(!path || !dot) return;

  stopFlow(name);
  dot.classList.add("running");

  const total = path.getTotalLength();
  const start = performance.now();

  function animate(now){
    const elapsed = (now - start) % durationMs;
    let progress = elapsed / durationMs;
    if(reverse) progress = 1 - progress;
    const point = path.getPointAtLength(total * progress);
    dot.setAttribute("cx", point.x);
    dot.setAttribute("cy", point.y);
    animations[name].frame = requestAnimationFrame(animate);
  }

  animations[name] = { frame: requestAnimationFrame(animate) };
}

function updatePowerFlow(d){
  const pv = Number(d.pv_kw) || 0;
  const load = Number(d.load_kw) || 0;
  const batteryCurrent = Number(d.battery_current) || 0;
  const gridConnected = Boolean(d.grid_connected);

  $("pvNode").classList.toggle("active", pv > 0.03);
  $("loadNode").classList.toggle("active", load > 0.03);
  $("batteryNode").classList.toggle("active", Math.abs(batteryCurrent) > 0.5);
  $("gridNode").classList.toggle("active", gridConnected);

  const speedFromPower = power => Math.max(900, 2600 - Math.min(power, 3) * 500);

  if(pv > 0.03) startFlow("pv", speedFromPower(pv), false);
  else stopFlow("pv");

  if(load > 0.03) startFlow("load", speedFromPower(load), false);
  else stopFlow("load");

  if(Math.abs(batteryCurrent) > 0.5){
    const batteryKw = Number(d.battery_power_kw) || 0;

    /*
     * The SVG battery path is drawn from the inverter down to the battery.
     * Positive current means discharge, so reverse the animation:
     * Battery -> Inverter.
     *
     * Negative current means charging, so use the path normally:
     * Inverter -> Battery.
     */
    const discharging = batteryCurrent > 0.5;
    startFlow("battery", speedFromPower(batteryKw), discharging);
  } else stopFlow("battery");

  if(gridConnected) startFlow("grid", 1800, false);
  else stopFlow("grid");
}

function addHistoryPoint(d){
  const now = new Date();
  history.labels.push(now.toLocaleTimeString([], {hour:"2-digit",minute:"2-digit",second:"2-digit"}));
  history.load.push(Number(d.load_kw) || 0);
  history.battery.push(Number(d.battery_power_kw) || 0);

  while(history.labels.length > CONFIG.chartPoints){
    history.labels.shift();
    history.load.shift();
    history.battery.shift();
  }
  drawChart();
}

function render(d){
  const percent = Number(d.battery_percent) || 0;
  const remaining = CONFIG.batteryNominalKwh * (percent / 100) * CONFIG.usableFraction;
  const batteryPower = Number(d.battery_power_kw) || 0;
  const current = Number(d.battery_current) || 0;
  const charging = current < -0.5;
  const discharging = current > 0.5;
  const runtime = discharging
    ? remaining / Math.max(batteryPower, 0.05)
    : null;

  const usableCapacity = CONFIG.batteryNominalKwh * CONFIG.usableFraction;
  const energyToFull = Math.max(usableCapacity - remaining, 0);
  const timeToFull = charging
    ? energyToFull / Math.max(batteryPower, 0.05)
    : null;

  $("batteryPercent").textContent = Math.round(percent);
  updateBatteryVisual(percent, charging);
  $("batteryVoltage").textContent = Number(d.battery_voltage || 0).toFixed(2);
  $("batteryCurrent").textContent = Math.abs(current).toFixed(1);
  $("batteryCurrentLabel").textContent =
    charging ? "Charging current" :
    discharging ? "Discharge current" :
    "Battery current";
  $("energyRemaining").textContent = remaining.toFixed(1);
  if (charging) {
    $("runtimeLabel").textContent = "Estimated time to full";
    $("runtime").textContent = formatRuntime(timeToFull);
  } else if (discharging) {
    $("runtimeLabel").textContent = "Estimated runtime";
    $("runtime").textContent = formatRuntime(runtime);
  } else {
    $("runtimeLabel").textContent = "Battery status";
    $("runtime").textContent = "Idle";
  }
  $("batteryState").textContent =
    discharging ? "Discharging" :
    charging ? "Charging" :
    "Idle";

  $("pvPower").textContent = Number(d.pv_kw || 0).toFixed(2);
  $("loadPower").textContent = Number(d.load_kw || 0).toFixed(2);
  $("netFlow").textContent = Number(d.load_kw || 0).toFixed(2);
  $("batteryPower").textContent = Math.abs(batteryPower).toFixed(2);
  $("batteryPowerLabel").textContent =
    charging ? "Battery charging" :
    discharging ? "Battery supplying" :
    "Battery power";
  $("gridStatus").textContent = d.grid_connected ? "Connected" : "Disconnected";

  $("pvFlowValue").textContent = `${Number(d.pv_kw || 0).toFixed(2)} kW`;
  $("gridFlowValue").textContent = d.grid_connected ? "Connected" : "0 W";
  const batteryDirection =
    discharging ? " → Supplying" :
    charging ? " ← Charging" :
    "";

  $("batteryFlowValue").textContent = `${Math.round(percent)}%${batteryDirection}`;
  $("loadFlowValue").textContent = `${Math.round((Number(d.load_kw)||0)*1000)} W`;

  $("solarToday").textContent = Number(d.solar_today_kwh || 0).toFixed(2);
  $("solarYear").textContent = Number(d.solar_year_kwh || 0).toFixed(2);
  $("solarTotal").textContent = Number(d.solar_total_kwh || 0).toFixed(2);

  updatePowerFlow(d);
  addHistoryPoint(d);

  $("updatedAt").textContent = `Updated ${new Date().toLocaleTimeString([], {hour:"2-digit",minute:"2-digit"})}`;
  $("connectionText").textContent = "Live";
  $("sourceNote").textContent =
    charging
      ? "Live data · charge time is an estimate"
      : "Connected to live inverter data";
  $("connectionDot").style.background = "var(--green)";
}

function drawChart(){
  const canvas = $("liveChart");
  const ctx = canvas.getContext("2d");
  const w = canvas.width, h = canvas.height;
  ctx.clearRect(0,0,w,h);

  const pad = {l:55,r:25,t:25,b:44};
  const plotW = w-pad.l-pad.r, plotH = h-pad.t-pad.b;
  const maxY = Math.max(...history.load,...history.battery,1) * 1.2;

  ctx.strokeStyle = "rgba(255,255,255,.08)";
  ctx.lineWidth = 1;
  for(let i=0;i<=4;i++){
    const y=pad.t+plotH*(i/4);
    ctx.beginPath();ctx.moveTo(pad.l,y);ctx.lineTo(w-pad.r,y);ctx.stroke();
  }

  function draw(values,color){
    if(values.length<2) return;
    ctx.strokeStyle=color;
    ctx.lineWidth=4;
    ctx.beginPath();
    values.forEach((v,i)=>{
      const x=pad.l+plotW*(i/(CONFIG.chartPoints-1));
      const y=pad.t+plotH*(1-v/maxY);
      i===0?ctx.moveTo(x,y):ctx.lineTo(x,y);
    });
    ctx.stroke();
  }

  draw(history.load,"#58d6df");
  draw(history.battery,"#45d275");

  ctx.fillStyle="#91aaa7";
  ctx.font="16px Inter";
  if(history.labels.length){
    ctx.fillText(history.labels[0],pad.l,h-14);
    const last=history.labels[history.labels.length-1];
    ctx.fillText(last,w-pad.r-75,h-14);
  }
}

async function refresh(){
  try{
    const res = await fetch(CONFIG.apiUrl,{cache:"no-store"});
    if(!res.ok) throw new Error(`HTTP ${res.status}`);
    const data = await res.json();
    if(data.success === false) throw new Error(data.error || "Live data unavailable");
    render(data);
  }catch(err){
    console.error("Energy dashboard:",err);
    $("connectionText").textContent = "Offline";
    $("connectionDot").style.background = "var(--yellow)";
    $("sourceNote").textContent = "Live data temporarily unavailable";
  }
}

refresh();
setInterval(refresh, CONFIG.refreshMs);